import type {
    ExpensePaymentMethod,
    ExpensePaymentStatus,
} from '@/lib/api/expense-api'

/** Trang + bộ lọc của màn Khoản chi, được giữ trên URL search param. */
export interface ExpensesSearch {
    q?: string
    category_id?: string
    payment_method?: ExpensePaymentMethod
    payment_status?: ExpensePaymentStatus
    page?: number
}

/**
 * Chuẩn hoá search param thô của màn Khoản chi.
 *
 * URL là nguồn sự thật nên giá trị đến từ đây không đáng tin: người dùng có thể
 * sửa tay, hoặc link cũ mang theo giá trị đã bỏ. Mỗi field vì vậy được whitelist,
 * giá trị lạ bị loại bỏ thay vì đẩy xuống API. `page` chỉ giữ lại khi > 1 để URL
 * ở trang đầu luôn sạch.
 */
export function normalizeExpensesSearch(
    search: Record<string, unknown>,
): ExpensesSearch {
    const out: ExpensesSearch = {}

    if (typeof search.q === 'string' && search.q) {
        out.q = search.q
    }
    if (typeof search.category_id === 'string' && search.category_id) {
        out.category_id = search.category_id
    }

    const method = search.payment_method
    if (method === 'cash' || method === 'bank_transfer') {
        out.payment_method = method
    }

    const status = search.payment_status
    if (status === 'paid' || status === 'unpaid') {
        out.payment_status = status
    }

    // Đến từ URL nên page thường là chuỗi ('?page=3'), không phải number.
    const page =
        typeof search.page === 'number' ? search.page : Number(search.page)
    if (Number.isFinite(page) && page > 1) {
        out.page = Math.floor(page)
    }

    return out
}
